import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'currencyUnits',
    standalone: false
})
export class CurrencyUnitsPipe implements PipeTransform {
  transform(value: any, unit?: string): any {
    /* This was created because in some modules, the values came from backend
    in Wh and in another ones, in MWh */
    if (unit) {
      switch (unit) {
        case 'M':
          return value / 1000000;
        case 'k':
          return value < 1000 ? value : value / 1000;
        default:
          return value;
      }
    }
    return '';
  }
}
